import React, { useEffect, useState } from 'react';
import { OpeningHoursComponent } from './OpeningHoursComponent';
import { SelectMultistore } from '../../components/select-multistore/select-multistore.component';
import { useStore } from '../../providers/store.provider';

const OpeningHoursPage = (props) => {
  const storeProvider = useStore();

  const [isMultiStore, setIsMultiStore] = useState(storeProvider.getMultistoreState());

  const selectedMultistore = storeProvider.selectedMultistore?.id;

  useEffect(() => {
    setIsMultiStore(storeProvider.getMultistoreState());
  }, [storeProvider]);

  return !isMultiStore || !(isMultiStore && !selectedMultistore) ? (
    <OpeningHoursComponent storeId={selectedMultistore} />
  ) : (
    <SelectMultistore />
  );
};

export default OpeningHoursPage;
